module.exports = __webpack_public_path__ + "img/setup-2.16aeef7f.png";